<div 
    *ngIf="!this.loading" class="z-20 fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75"
    (click)="$event.preventDefault(); onCloseClick();"
>
    <div class="max-h-screen w-full flex flex-col items-center justify-center overflow-hidden">
        <div class="h-full w-full max-w-screen-lg flex flex-col my-6 p-8 bg-white rounded-md shadow-lg overflow-y-auto" (click)="$event.stopPropagation()">
            <h2 class="w-full text-center oswald-font text-2xl text-nside-orange-400 mb-4">
                Select A Tip Below To Link It To This Case
            </h2>
            
            <div class="w-full h-full overflow-y-auto rounded-md">
                <table class="w-full text-left">
                    <thead class="oswald-font text-gray-700 uppercase bg-main-background">
                        <tr>
                            <th scope="col" class="px-4 py-3 w-60 min-w-40">Summary</th>
                            <th scope="col" class="px-4 py-3 w-40 min-w-32">Date</th>
                            <th scope="col" class="px-4 py-3 w-60 min-w-40">Contact Info</th>
                            <th scope="col" class="px-4 py-3 w-32 min-w-24">Action</th>
                        </tr>
                    </thead>
            
                    <tbody>
                        <tr *ngFor="let tip of tips" class="bg-white border-b">
                            
                            <!-- SUMMARY -->
                            <td class="px-4 py-4 align-top text-nside-gray-400">
                                <div class="max-w-60 max-h-40 overflow-y-auto whitespace-normal break-words">
                                    {{ tip.tip_summary }}
                                </div>
                            </td>
            
                            <!-- DATE -->
                            <td class="px-4 py-4 align-top text-nside-gray-400">
                                <div class="max-h-10 min-w-28 overflow-y-auto whitespace-normal break-words">
                                    {{ tip.submission_date | date:'short' }}
                                </div>
                            </td>
            
                            <!-- CONTACT INFO -->
                            <td class="px-4 py-4 align-top text-nside-gray-400">
                                <div class="flex flex-col max-w-40 max-h-32 overflow-y-auto">
                                    <span *ngIf="tip.full_name"><strong>Name:</strong> {{ tip.full_name }}</span>
                                    <span *ngIf="tip.phone"><strong>Phone:</strong> {{ tip.phone }}</span>
                                    <span *ngIf="tip.email"><strong>Email:</strong> {{ tip.email }}</span>
                                </div>
                            </td>
            
                            <!-- SELECT BUTTON -->
                            <td class="px-4 py-4">
                                <button
                                    type="button"
                                    class="w-24 flex items-center justify-center px-4 py-1.5 rounded-md border border-nside-orange-200 bg-gradient-to-b oswald-font text-white from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200"
                                    (click)="selectTip.emit({ summary: tip.tip_summary, id: tip.id })"
                                >
                                    Select
                                </button>
                            </td>
            
                        </tr>
                    </tbody>
                </table>
            </div>
            
            <div class="mt-4 flex justify-end gap-4">
                <button
                    class="py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                    (click)="$event.preventDefault(); onCloseClick();"
                >
                    Close
                </button>
            </div>
            
        </div>
    </div>
</div>

<popup-message 
    [type]="messageModal"
    (close)="resetMessageModal()"
    [message]="popupMessage"
></popup-message>
